import { getUserInfo } from '@/apis';

interface UserInfo {
    name?: string;
    age?: number;
}

interface UserState {
    userInfo: UserInfo;
}

interface SetUserPayload {
    payload: UserInfo;
}

interface GetUserInfoPayload {
    payload?: Record<string, any>;
}

export default {
    name: 'user',
    initialState: {
        userInfo: {} as UserInfo,
    },
    reducers: {
        setUser: (state: UserState, { payload }: SetUserPayload) => {
            state.userInfo = payload;
        },
    },
    effects: (dispatch: any) => {
        return {
            async getUserInfo(state: UserState, { payload: param = {} }: GetUserInfoPayload = {}) {
                // 异步请求
                // setTimeout(() => {
                //     dispatch.user.setUser({
                //         name: "yao guan shou",
                //         age: 35,
                //     });
                // }, 3000);

                const { data } = await getUserInfo(param).catch(() => {
                    return {
                        data: {},
                    };
                });

                dispatch.user.setUser(data);

                return data;
            },
        };
    },
};
